/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { mFIATPInventoryDynamicAsync } from '../actions/CoreProductDataActionExtension.g';
import {
    IMFIATPInventoryDynamicResponse, IMFICartLine, IMFICLDeliveryScheduleParameters
} from '../actions/CoreProductDataServiceEntities.g';

/**
 * MfiAtpInventory Input Action
 */
export class MfiAtpInventoryInput implements Msdyn365.IActionInput {
    // MfiAtpInventory: Construct the input needed to run the action
    public inventoryType: string;
    public weeks: number;
    public storeId: string;
    public page: string;
    public requestedDate: string;
    public zipCode: string;
    public itemLines: IMFICartLine[];

    constructor(inventoryType: string, weeks: number, storeId: string, page: string, requestedDate: string, zipCode: string, itemLines: IMFICartLine[]) {
        this.inventoryType = inventoryType;
        this.weeks = weeks;
        this.storeId = storeId;
        this.page = page;
        this.requestedDate = requestedDate;
        this.zipCode = zipCode;
        this.itemLines = itemLines;
    }

    // MfiAtpInventory: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `MfiAtpInventory`;
    public getCacheObjectType = () => 'MfiAtpInventory';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// MfiAtpInventory: Create a data model here or import one to capture the response of the action
export interface IMfiAtpInventoryData {
    text: string;
}


/**
 * MfiAtpInventory: Use this function to call your action and process the results as needed
 */
export async function mfiAtpInventoryAction(input: MfiAtpInventoryInput, ctx: Msdyn365.IActionContext): Promise<IMFIATPInventoryDynamicResponse> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    const requestBody: IMFICLDeliveryScheduleParameters = {
        InventoryType: input.inventoryType,
        Weeks: input.weeks,
        StoreId: input.storeId,
        Page: input.page,
        RequestedDate: input.requestedDate,
        ZipCode: input.zipCode,
        ItemLines: input.itemLines
    };

    const response = await mFIATPInventoryDynamicAsync({ callerContext: ctx }, requestBody);
    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IMFIATPInventoryDynamicResponse>>mfiAtpInventoryAction,
    // MfiAtpInventory: Give your data action a unique id
    id: 'MfiAtpInventory'
    // input: createInput
    // MfiAtpInventory: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
